module.exports = __webpack_public_path__ + "img/logo_bengkel_next.b87fdf5b.png";